import { Route, RouteObject } from "react-router-dom";

export const renderRoutes = (routes: RouteObject[]) =>
  routes.map((r, i) => (
    <Route key={i} path={r.path} element={r.element}>
      {r.children?.map((c, j) =>
        c.index ? (
          <Route key={j} index element={c.element} />
        ) : (
          <Route key={j} path={c.path} element={c.element} />
        ),
      )}
    </Route>
  ));
